import * as React from "react";
const SvgFileAslog20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 15,
        height: 18,
        fill: "black",
        viewBox: "0 0 15 18"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M6.586 0H14v9h-2V2H8v6H2v8h3v2H0V6.586L6.586 0ZM3.414 6H6V3.414L3.414 6ZM8 10.293 9.707 12 8 13.707 7.293 13l1-1-1-1L8 10.293Zm7 1.207h-4.5v1H15v-1Zm-4.5 4H15v1h-4.5v-1Zm-.793.5L8 14.293 7.293 15l1 1-1 1 .707.707L9.707 16Z",
      clipRule: "evenodd"
    })
  );
export default SvgFileAslog20Px;
